import type { ReactNode } from 'react';

import { FormGroup, Paper } from '@mui/material';

type CheckboxFilterPanelProps = { children: ReactNode };

export const CheckboxFilterPanel = ({ children }: CheckboxFilterPanelProps) => (
  <Paper
    elevation={0}
    sx={{
      py: 0.5,
      border: '1px solid',
      borderColor: 'grey.300',
      borderRadius: 2,
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    }}
  >
    <FormGroup
      onKeyDown={e => {
        if (
          e.key === 'Enter' &&
          e.target instanceof HTMLInputElement &&
          e.target.type === 'checkbox'
        ) {
          e.preventDefault();
          e.target.click();
        }
      }}
    >
      {children}
    </FormGroup>
  </Paper>
);
